module.exports = __webpack_public_path__ + "img/banner1.ece662b3.jpg";